import styled from 'styled-components';
import ArrowIcon from '@catalogo/theme-svg/arrow.svg';

const Container = styled.div`
  border: 1px solid #dfdfdf;
  position: relative;
  background: #fafafa;
  border-radius: 8px;
  margin: 15px 0 22px 0;
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px 8px;
  margin: 0px 8px;
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  color: #282828;
  cursor: pointer;
`;

const WrapperTitle = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  color: #6f6f6f;
  text-transform: none;
`;

const ArrowIconUI = styled(ArrowIcon)<{ $isVisible: boolean | undefined }>`
  fill: ${({ theme }) => theme.primaryColor};
  width: 12px;
  height: 12px;
  display: flex;
  flex-direction: column;
  align-self: center;
  ${({ $isVisible }) => $isVisible && `transform: rotate(180deg);`};
  transition: transform 500ms;
`;

const ContentWrapper = styled.div<any>`
  background: #fafafa;
  overflow: hidden;
  transition: max-height 0.5s 0s ease-in-out;
`;

const DivUi = styled.div`
  border-top: 1px solid #dfdfdf;
`;

const List = styled.ul`
  margin: 8px 5px 0 18px;
  text-transform: none;

  > li {
    font-size: 12px;
    line-height: 18px;
    list-style: disc;
    list-style-position: inside;
    margin-bottom: 8px;
  }
`;

export { TitleContainer, ArrowIconUI, Container, ContentWrapper, WrapperTitle, DivUi, List };
